import React from "react";
import { Phone, MessageCircle, Send, Instagram, Facebook } from "lucide-react";
import { usPhoneE164 } from "../lib/format";

// digitsOnly for wa.me / tel links
function digits(phone) {
  return String(phone || "").replace(/\D/g, "").slice(-10);
}

function waLink(phone) {
  const d = digits(phone);
  return d ? `https://wa.me/1${d}` : null;
}

function telLink(phone) {
  const e = usPhoneE164(phone);
  return e || (digits(phone) ? `tel:+1${digits(phone)}` : null);
}

const baseBtn =
  "inline-flex items-center justify-center gap-1.5 px-3 min-h-[44px] sm:min-h-[34px] sm:px-2.5 py-1.5 rounded-lg text-xs font-medium border transition-colors";

export function ContactActions({ client, size = "sm", testIdPrefix = "contact" }) {
  if (!client) return null;
  const phone = client.phone;
  const tel = telLink(phone);
  const wa = waLink(phone);
  const insta =
    client.has_instagram && client.instagram_handle
      ? `https://instagram.com/${String(client.instagram_handle).replace(/^@/, "")}`
      : null;
  const fb =
    client.has_facebook && client.facebook_handle
      ? client.facebook_handle.startsWith("http")
        ? client.facebook_handle
        : `https://${client.facebook_handle}`
      : null;
  const tg =
    client.has_telegram && phone ? `https://t.me/+1${digits(phone)}` : null;

  const onClick = (e) => e.stopPropagation();
  const pad = size === "lg" ? "px-3 py-2 text-sm" : "";

  return (
    <div className="flex flex-wrap gap-1.5" onClick={onClick}>
      {tel && (
        <a
          href={tel}
          data-testid={`${testIdPrefix}-call`}
          className={`${baseBtn} ${pad} bg-slate-50 border-slate-200 text-slate-700 hover:bg-slate-100`}
        >
          <Phone size={13} /> Ligar
        </a>
      )}
      {wa && client.has_whatsapp && (
        <a
          href={wa}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testIdPrefix}-whatsapp`}
          className={`${baseBtn} ${pad} bg-emerald-50 border-emerald-200 text-emerald-800 hover:bg-emerald-100`}
        >
          <MessageCircle size={13} /> WhatsApp
        </a>
      )}
      {tg && (
        <a
          href={tg}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testIdPrefix}-telegram`}
          className={`${baseBtn} ${pad} bg-sky-50 border-sky-200 text-sky-800 hover:bg-sky-100`}
        >
          <Send size={13} /> Telegram
        </a>
      )}
      {insta && (
        <a
          href={insta}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testIdPrefix}-instagram`}
          className={`${baseBtn} ${pad} bg-pink-50 border-pink-200 text-pink-800 hover:bg-pink-100`}
        >
          <Instagram size={13} /> Instagram
        </a>
      )}
      {fb && (
        <a
          href={fb}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testIdPrefix}-facebook`}
          className={`${baseBtn} ${pad} bg-blue-50 border-blue-200 text-blue-800 hover:bg-blue-100`}
        >
          <Facebook size={13} /> Facebook
        </a>
      )}
    </div>
  );
}
